export function composeProfiles(base, modules) {
    const composed = { ...base };
    for (const module of modules) {
        if (module.profile)
            composed[module.code] = module.profile;
    }
    return composed;
}
export function composePacks(base, modules) {
    const composed = { ...base };
    for (const module of modules) {
        for (const pack of module.packs ?? [])
            composed[pack.code] = pack;
    }
    return composed;
}
export function composeClasses(base, modules) {
    const composed = { ...base };
    for (const module of modules) {
        for (const contribution of module.moduleKeys) {
            composed[contribution.key] = contribution.moduleClass;
        }
    }
    return composed;
}
export function composeRoleUi(base, modules) {
    const composed = { ...base };
    for (const module of modules) {
        for (const profile of module.roleUi ?? [])
            composed[profile.code] = profile;
    }
    return composed;
}
export function composeWidgets(base, modules) {
    const composed = { ...base };
    for (const module of modules) {
        for (const widget of module.widgets ?? [])
            composed[widget.key] = widget;
    }
    return composed;
}
/** Every key a module declares, whatever its class. */
export function declaredKeys(modules) {
    return modules.flatMap((m) => m.moduleKeys.map((c) => c.key));
}
//# sourceMappingURL=compose.js.map